import { render } from "./copy.vue?vue&type=template&id=2895210c&scoped=true"
import script from "./copy.vue?vue&type=script&lang=js"
export * from "./copy.vue?vue&type=script&lang=js"

import "./copy.vue?vue&type=style&index=0&id=2895210c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.5.16_vue@3.5.16_typescript@4.8.4__webpack@5.84.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2895210c"]])

export default __exports__